import {
  ScissorsIcon,
  SparklesIcon,
  PaintBrushIcon,
  HeartIcon,
  BeakerIcon,
} from "@heroicons/react/24/outline";
import { GiNails, GiDropEarrings, GiLips } from "react-icons/gi";
import { FaSpa } from "react-icons/fa";

export const CATEGORIES = [
  { id: "salon", name: "Salon", icon: ScissorsIcon },
  { id: "barber", name: "Barber", icon: ScissorsIcon },
  { id: "nails", name: "Nails", icon: GiNails },
  { id: "spa", name: "Spa & Sauna", icon: FaSpa },
  { id: "medspa", name: "Medspa", icon: BeakerIcon },
  { id: "massage", name: "Massage", icon: FaSpa },
  { id: "fitness", name: "Fitness", icon: SparklesIcon },
  { id: "physiotherapy", name: "Physiotherapy", icon: HeartIcon },
  { id: "health", name: "Health Practice", icon: BeakerIcon },
  { id: "tattoo", name: "Tattoo & Piercing", icon: PaintBrushIcon },
  { id: "pet-grooming", name: "Pet Grooming", icon: SparklesIcon },
  { id: "tanning", name: "Tanning Studio", icon: SparklesIcon },
];

export const BOOKING_STATUS = {
  PENDING: { label: "Pending", color: "warning" },
  CONFIRMED: { label: "Confirmed", color: "info" },
  ACCEPTED: { label: "Accepted", color: "info" },
  DECLINED: { label: "Declined", color: "danger" },
  PAID: { label: "Paid", color: "success" },
  COMPLETED: { label: "Completed", color: "success" },
  CANCELLED: { label: "Cancelled", color: "danger" },
  REFUNDED: { label: "Refunded", color: "info" },
  NO_SHOW: { label: "No Show", color: "danger" },
};

export const DAYS_OF_WEEK = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const LANGUAGES = [
  "English",
  "Luganda",
  "Swahili",
  "French",
  "Runyankole",
];

export const GENDER_PREFERENCES = [
  { value: "any", label: "Any" },
  { value: "male_only", label: "Male Clients Only" },
  { value: "female_only", label: "Female Clients Only" },
];
